import React from 'react'
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import {Row,Col} from 'react-bootstrap';
import { GoPeople } from "react-icons/go";
import AutoAwesomeOutlinedIcon from '@mui/icons-material/AutoAwesomeOutlined';
const Weinclude = () => {
  return (
    <div className='mb-5'>
      <div style={{ textAlign: 'center',padding: '40px 20px'}}>
        <h1>What included</h1>
            <p className="pricing-subtitle">
            Get 100+ feature out of the box with the world's leading customer insights hub
            </p>
        </div>
        <div className="container mb-5">
      <Row className="gy-4">
        {[
          { title: 'Automated Lead Assignment', description: 'Distribute leads automatically based on predefined rules, such as location, expertise, availability, or round-robin distribution.' },
          { title: 'Customizable Rules Engine', description: 'Set up rules and criteria to match leads with the most suitable sales representatives.' },
          { title: 'Lead Tracking & Management', description: 'Monitor lead status, activity history, and engagement for better decision-making.' },
          { title: 'Real-Time Notifications & Alerts', description: 'Keep sales teams informed with instant notifications about new lead assignments.' },
          { title: 'Performance Analytics & Reporting', description: ' Generate reports to analyze lead response times, conversion rates, and team performance.' },
          { title: 'Geo-Targeting & Lead Prioritization', description: 'Assign leads based on geographical location or urgency for better conversions.' },
        ].map((item, index) => (
          <Col key={index} md={4} className="d-flex">
            <Card sx={{ minWidth: 275, flex: 1, minHeight:220 }}>
              <CardContent>
                <div>
                  <AutoAwesomeOutlinedIcon style={{ color: '#2B78DF' }} size={30} />
                </div>
                <div className="mt-3">
                  <h5>{item.title}</h5>
                  <span style={{ color: '#7c7878' }}>{item.description}</span>
                </div>
              </CardContent>
            </Card>
          </Col>
        ))}
      </Row>
    </div>
    </div>
  )
}

export default Weinclude